var Product_Panels = {
    init:function(){
        $(".find-frequency").on("click touchend", function(e){
            if(e.type == "touchend"){
                $(this).off("click");
            }
            setTimeout(function(){
                $(".fixed-panel.frequency").addClass("open");
            }, 40);
        });

        $(".learn-more").on("click touchend", function(e){
            if(e.type == "touchend"){
                $(this).off("click");
            }
            setTimeout(function(){
                $(".fixed-panel.abonnement").addClass("open");
            }, 40);
        });

        $(".fixed-panel .shadow").on("click touchend", function(e){
            if(e.type == "touchend"){
                $(this).off("click");
            }

            setTimeout(function(){
                $(".fixed-panel").removeClass("open");
            }, 40);
        });


        $(".fixed-panel .btn-fermer").on("click touchend", function(e){
            if(e.type == "touchend"){
                $(this).off("click");
            }

            setTimeout(function(){
                $(".fixed-panel").removeClass("open");
            }, 40);
        });

    }
}
$(window).on("load", function(){
    if($("#product__page--container").length){
        Product_Panels.init();
    }
})